import styled from 'styled-components';
import useMarketCode from '../../../data/branch/useMarketCode';

const Color = styled.span`
  color: var(--c-quick-menu-highlight);
`;

const Bold = styled.span`
  font-weight: var(--font-weight-bold);
`;

interface HighlightProps {
  text: string;
  highlight?: string;
}

const Highlight = ({ text, highlight }: HighlightProps) => {
  const [marketCode] = useMarketCode();

  if (!highlight || !highlight.trim()) {
    return <>{text}</>;
  }

  // Split the highlight string on spaces, escape special regex characters, and join with '|'
  const words = highlight.split(' ').map((word) => word.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));
  const regex = new RegExp(`(${words.join('|')})`, 'gi');

  const parts = text.split(regex);

  const renderText = (part: string, i: number) => {
    if (regex.test(part)) {
      // Use a different component based on the market code
      const HighlightComponent = marketCode === 'SE' ? Bold : Color;
      return <HighlightComponent key={i}>{part}</HighlightComponent>;
    }
    return <span key={i}>{part}</span>;
  };

  return <span>{parts.filter(Boolean).map(renderText)}</span>;
};

export default Highlight;
